var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isExternal)?_c('a',_vm._b({attrs:{"href":_vm.to}},'a',_vm.$attrs,false),[_vm._t("default")],2):_c('router-link',_vm._b({attrs:{"to":_vm.to}},'router-link',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }